<template>
  <div style="height: 100dvh;">
    <div
      class="col-lg-12"
      style="padding-top: 20px; padding-bottom: 20px"
    ></div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-3" style="padding-bottom: 20px">
          <base-button
            type="primary"
            v-on:click="getAddUser('noncontractor')"
            v-if="activeTab != 5"
            >+ Add Users</base-button
          >
          <base-button
            type="primary"
            v-on:click="getAddUser('contractor')"
            v-if="activeTab == 5"
            >+ Add Users</base-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div id="app">
            <div class="tabs">
              <div class="tab-list" style="display: flex">
                <div
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :class="{
                    'first-tab': index === 0,
                    'other-tab': index !== 0 && index !== 5,
                    'last-tab': index === 5,
                    'inactive-tab': activeTab !== index,
                  }"
                  @click="activeTab = index"
                  style="z-index: 999"
                >
                  <p
                    :class="{
                      'active-tab-title': activeTab === index,
                      'inactive-tab-title': activeTab !== index,
                    }"
                  >
                    {{ tab.name }} <span v-if="accessid == 1 ">({{ tab.total }})</span>
                  </p>
                </div>
              </div>
              <card class="card-eprf">
                <div class="tab-content">
                  <div class="col-lg-12">
                    <div
                      v-for="(tab, index) in tabs"
                      :key="index"
                      v-show="activeTab === index"
                    >
                      <div v-if="tab.name == 'AFES'" >
                        <!-- example only -->
                        <Afes :tot="makdia"></Afes>
                      </div>
                      <div v-else-if="tab.name == 'Cust. Land'">
                        <!-- example only -->
                        <CustLand :tot="makdia"></CustLand>
                      </div>
                      <div v-else-if="tab.name == 'Cust. Vessel'">
                        <!-- example only -->
                        <CustVessel :tot="makdia"></CustVessel>
                      </div>
                      <div v-else-if="tab.name == 'Vendor'">
                        <!-- example only -->
                        <Vendor :tot="makdia"></Vendor>
                      </div>
                      <div v-else-if="tab.name == 'Authorities'">
                        <!-- example only -->
                        <Authorities :tot="makdia"></Authorities>
                      </div>
                      <div v-else-if="tab.name == 'Execution Team'">
                        <!-- example only -->
                        <Contractor :tot="makdia"></Contractor>
                      </div>
                      <div v-else>
                        {{ tab.content }}
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";
import Afes from "../../../../src/pages/Dashboard/Admin/UserManagement/Afes.vue";
import CustLand from "../../../../src/pages/Dashboard/Admin/UserManagement/CustLand.vue";
import CustVessel from "../../../../src/pages/Dashboard/Admin/UserManagement/CustVessel.vue";
import Vendor from "../../../../src/pages/Dashboard/Admin/UserManagement/Vendor.vue";
import Authorities from "../../../../src/pages/Dashboard/Admin/UserManagement/Authorities.vue";
import Contractor from "../../../../src/pages/Dashboard/Admin/UserManagement/Contractor.vue";

export default {
  name: "Users",

  components: {
    Card,
    Afes,
    CustLand,
    CustVessel,
    Vendor,
    Authorities,
    Contractor,
  },
  props: {
    tot: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      condition: true,
      activeTab: 0,
      tabs: [
        { name: "AFES", content: "Content for Tab 1", total: 0 },
        { name: "Cust. Land", content: "Content for Tab 2", total: 0 },
        { name: "Cust. Vessel", content: "Content for Tab 3",total: 0 },
        { name: "Vendor", content: "Content for Tab 4",total: 0 },
        { name: "Authorities", content: "Content for Tab 5",total: 0 },
        { name: "Execution Team", content: "Content for Tab 6" ,total: 0},
      ],
      accessid: 0,
      
    };
  },
  methods: {
    makdia(flag, total, accessid){
      this.accessid = accessid
      for(var i=0; i<this.tabs.length; i++){
        if(flag == this.tabs[i].name){
          this.tabs[i].total = total
        }
      }
    
    },
    getDownload() {},
    getAddUser(flag) {
      if (flag == "noncontractor") {
        // active tab determine user type and path
        // AFES
        if (this.activeTab == 0) {
          this.$router.push("/AddUser/afes/add/add");
        }

        // cust-land
        if (this.activeTab == 1) {
          this.$router.push("/AddUser/land/add/add");
        }

         // cust-vessel
         if (this.activeTab == 2) {
          this.$router.push("/AddUser/vessel/add/add");
        }

        // vendor
        if (this.activeTab == 3) {
          this.$router.push("/AddUser/vendor/add/add");
        }

        // authorities
        if (this.activeTab == 4) {
          this.$router.push("/AddUser/authority/add/add");
        }
      } else if (flag == "contractor")  {
        this.$router.push("/AddContractor/add/add");
      } else {

      // customer Sales Purchase Products
      if(this.activeTab == 5){
        this.$router.push("/BrowseProduct");
      }

     // customer Sales Add to cart
     if(this.activeTab == 6){
      this.$router.push("/Cart")
     }}
    },
  },
  created() {
    console.log(sessionStorage.getItem("usertab"));
    if (sessionStorage.getItem("usertab") == 0) {
      this.activeTab = 0;
    } else if (sessionStorage.getItem("usertab") == 1) {
      this.activeTab = 1;
    } else if (sessionStorage.getItem("usertab") == 2) {
      this.activeTab = 2;
    } else if (sessionStorage.getItem("usertab") == 3) {
      this.activeTab = 3;
    } else if (sessionStorage.getItem("usertab") == 4) {
      this.activeTab = 4;
    } else if (sessionStorage.getItem("usertab") == 5) {
      this.activeTab = 5;
    } else {
      this.activeTab = 0;
    }},
  computed: {
    tabTitle() {
      return this.condition ? "active-tab-title" : "inactive-tab-title";
    },
  },
  watch: {
    activeTab() {
      sessionStorage.setItem("usertab", this.activeTab);
    },
  },
};
</script>
<style>
.first-tab {
  cursor: pointer;
  border-top-left-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}

.other-tab {
  cursor: pointer;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 150px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
  color: #358CCB;
}

.last-tab {
  cursor: pointer;
  border-top-right-radius: 10px;
  margin-right: 3px;
  background-color: white;
  box-shadow: inset;
  width: 180px;
  padding: 5px 20px;
  border-top: 5px solid #358CCB;
}
.inactive-tab {
  background-color: #e6e6e6;
  border: none;
  color: #A5A5A5;
}
.active-tab-title {
  color: #358CCB;
  text-align: center;
}
.inactive-tab-title {
  color: #A5A5A5;
  text-align: center;
  border-top: 5px solid transparent;
}
</style>
